import * as Yup from 'yup'

import { getDailyImpressionsValidation } from '../../../../../Google/UploadGoogleAdCreative/UploadGoogleAdCreativeForm/CampaignForm/fields'
import { IMPRESSIONS } from '../../../../UploadAdCreative/fields'

export const getValidationSchema = ({ remainingImpressions, campaign, initialCampaignImpressionsDaily }) => {
  const startDate = campaign?.date_start
  const endDate = campaign?.date_stop

  return Yup.object({
    [IMPRESSIONS]: Yup.number().test({
      name: 'Edit campaign daily impressions validation based on number of days',

      test: (value, context) => {
        return getDailyImpressionsValidation({
          remainingImpressions,
          value,
          context,
          startDate,
          endDate,
          initialCampaignImpressionsDaily
        })
      }
    })
  })
}
